import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import { register } from "swiper/element/bundle";
import { loadGoogleMaps } from "./utils/googleMaps";

register();

const root = ReactDOM.createRoot(document.getElementById('root'));

loadGoogleMaps()
  .catch(() => null)
  .finally(() => {
    root.render(
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    );
    reportWebVitals();
  });
